import DefaultFavorites from './DefaultFavorites';

export default DefaultFavorites;
